
import { CLOSECURRENTTAG } from '@/store/user/types'
import goodsManage from '@/store/goodsManage/index.js'
import { ATTRIBUTES, DICTGETCHILDS2, SUPPLIERGETLISTS, GOODSGETGOODS, GETCOMPANY, CLASSIFICATION } from '@/store/goodsManage/types.js'
import user from '@/store/user/index'
let mixin = {
  data () {
    return {
      goodsList: {
        rows: [
          {
            ceshi1: '装卸费',
            ceshi2: '',
            ceshi3: '',
            ceshi4: '',
            smallestUnit: 0,
            smallestRule: {
              a: 4,
              b: 4,
              c: 4
            }
          }
        ]
      },
      fieldList: [
        { label: '收费项目', prop: 'ceshi1' },
        { label: '计算方式', prop: 'ceshi2', type: 'slot' },
        { label: '计算单位', prop: 'ceshi3', type: 'slot' },
        { label: '单价（元）', prop: 'ceshi4', type: 'slot' },
        { label: '', prop: 'ceshi5', type: 'slot' }
      ],
      formInfo: {
        ref: null,
        data: {
          name: '',
          goodsAtt: 'GOODS_ATT_NORMAL',
          minUnit: 'GOOD_UNIT_PIECE',
          maxUnit: 'GOOD_UNIT_BOX',
          box: '',
          boxWide: '0',
          volume: '',
          weightType: 'GOODS_WEIGHT_TYPE_HEAVY',
          url: '',
          ygcCode: ''
        },

        rules: {},
        labelWidth: '160px'
      },
      formInfo2: {
        ref: null,
        data: {
          supplierCode: '',
          standard: '',
          boxLong: '0',
          boxHigh: '0',
          weight: '0',
          standardCode: '1',
          expDays: ''
        },
        rules: {},
        labelWidth: '120px'
      },
      isClearValivitor: false
    }
  },
  mounted () {
    // 初始化表单验证
    this.formInfo.rules = this.$initRules(this.formFieldList)
    this.formInfo2.rules = this.$initRules(this.formFieldList2)
    setTimeout(() => {
      this.formInfo2.ref.clearValidate()
      this.formInfo.ref.clearValidate()
      this.isClearValivitor = true
    }, 1)

    // 获取下拉框 - 商品属性
    let params = {
      parentCode: 'GOODS_ATT'
    }
    this.$store.dispatch(ATTRIBUTES, params)

    // 获取下拉框 - 商品类型
    let params2 = {
      parentCode: 'GOODS_WEIGHT_TYPE'
    }
    this.$store.dispatch(DICTGETCHILDS2, params2)

    let params3 = {
      parentCode: 'GOODS_SPECIES'
    }
    this.$store.dispatch(CLASSIFICATION, params3)
    let params4 = {
      warehouseCode: this.$route.params.warehouseCode
    }
    // 获取下拉框 - 供应商
    this.$store.dispatch(SUPPLIERGETLISTS, params4)
    // 获取单位
    this.getCompany()
    this.getList()
  },
  computed: {
    formFieldList () {
      let list = [
        { label: '商品名称', prop: 'name', type: 'input', required: true, min: 1, max: 40 },
        { label: '商品属性', prop: 'goodsAtt', type: 'select', required: true, options: this.attributes },
        { label: '最小单位显示名称(件)', prop: 'minUnit', type: 'select', required: true, options: this.companyList },
        { label: '最大单位显示名称(箱)', prop: 'maxUnit', type: 'select', required: true, options: this.companyList },
        { label: '箱规', prop: 'box', required: true, type: 'slot', append: '件/箱', validator: this.numberValidator },
        { label: '外箱宽', prop: 'boxWide', type: 'slot', required: true, append: 'cm', validator: this.validateBoxWide },
        { label: '外箱体积', prop: 'volume', type: 'input', required: true, append: 'cm³', placeholder: '-', disabled: true },
        { label: '商品类型', prop: 'weightType', type: 'select', required: true, options: this.goodsWeightTypeSelect },
        { label: '商品条码(69码)', prop: 'barCode', type: 'input', validator: this.checkCharacter },
        { label: '分类', prop: 'ygcCode', type: 'select', required: true, options: this.classification }
      ]
      if (this.editType === 2) {
        list.unshift({ label: '商品编码', prop: 'goodsCode', type: 'slot' })
      }
      if (this.userinfo.identity === 3) {
        list.push()
      }
      return list
    },
    // 商品类型 - 下拉框
    attributes () {
      return goodsManage.state.attributes
    },
    classification () {
      return goodsManage.state.classification
    },
    goodsWeightTypeSelect () {
      return goodsManage.state.goodsWeightTypeSelect
    },
    supplierSelect () {
      return goodsManage.state.supplierSelect
    },
    goodsManageMark () {
      return goodsManage.state.goodsManageMark
    },
    changeCeshi3 () {
      let ceshi3 = '-'
      let code = ''
      if (this.goodsList.rows[0].ceshi2 === '1') {
        ceshi3 = '箱'
        code = 'RECKON_TYPE_BOX'
      } else if (this.goodsList.rows[0].ceshi2 === '2' && this.formInfo.data.weightType === 'GOODS_WEIGHT_TYPE_HEAVY') {
        ceshi3 = '吨'
        code = 'RECKON_TYPE_TONS'
      } else if (this.goodsList.rows[0].ceshi2 === '2' && this.formInfo.data.weightType === 'GOODS_WEIGHT_TYPE_LIGHT') {
        ceshi3 = '立方'
        code = 'RECKON_TYPE_CUBIC'
      }
      if (ceshi3 !== '-') {
        this.changeGoodList(code)
      }
      return ceshi3
    },
    companyList () {
      return goodsManage.state.companyList
    },
    userinfo () {
      return user.state.userinfo
    }
  },
  watch: {
    'formInfo.data.supplierCode' (newVal) {
      this.checkList = []
    },
    allTotal: {
      deep: true,
      handler (val) {
        if (val !== '') {
          this.formInfo.data.volume = val.toFixed(6)
        }
      }
    },
    goodsManageMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          goodsManage.state.goodsManageMark = 0
          this.$store.dispatch('tagsView/setBeforePageName', 'goodsmanage')
          this.$store.dispatch(CLOSECURRENTTAG, '/goodsmanage/goodsmanage')
        }
      }
    },
    costMask: {
      deep: true,
      handler (val) {
        if (val === 1) {
          goodsManage.state.costMask = 0
          this.$store.dispatch('tagsView/setBeforePageName', 'goodsmanage')
          this.$store.dispatch(CLOSECURRENTTAG, '/goodsmanage/goodsmanage')
        }
      }
    },
    $route (to, from) {
      if (this.$route.params.code) {
        this.id = this.$route.params.code
        this.getList()
      }
    }
  },
  methods: {
    // 获取列表
    getList () {
      if (!this.id) return false
      let params = {
        code: this.id
      }
      this.$store.dispatch(GOODSGETGOODS, params)
    },
    changeGoodList (code) {
      this.goodsList.rows[0].ceshi3 = code
    },
    // 不足一箱、重量体积计算规则
    update (formInfo) {
      let {smallestRule, smallestUnit} = formInfo
      this.goodsList.rows[0].smallestUnit = smallestUnit
      this.goodsList.rows[0].smallestRule = smallestRule
    },
    // 填写验证
    formValid () {
      let { supplierCode, type, loading } = this.formInfo.data
      if (!supplierCode || supplierCode === '' || !type || type === '') {
        this.$message.warning('请先选择 供应商 和 任务类型')
        return false
      }
      if (type === 'TASK_TYPE_ARRIVE' || type === 'TASK_TYPE_EMPTY' || type === 'TASK_TYPE_OTHER_OUT') {
        if (!loading || loading === '' || loading === undefined) {
          this.$message.warning('请选择 装卸服务')
          return false
        }
      }
      return true
    },

    numberValidator (rule, value, callback) {
      this.validateNum2(rule, value, callback, 'box')
    },
    validateBoxWide (rule, value, callback) {
      this.validateNum(rule, value, callback, 'boxWide')
    },
    validateBoxLong (rule, value, callback) {
      this.validateNum(rule, value, callback, 'boxLong')
    },
    validateBoxHigh (rule, value, callback) {
      this.validateNum(rule, value, callback, 'boxHigh')
    },
    validateWeight (rule, value, callback) {
      this.validateNum(rule, value, callback, 'weight')
    },
    validateNum2 (rule, value, callback, name) {
      let reg = /^[1-9]\d*$/
      if (value === '') {
        callback(new Error('请输入'))
      } else if (!reg.test(value)) {
        return callback(new Error('请输入非0的正整数'))
      } else {
        // 四舍五入
        value = Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2)
        // 不足补位
        if (name === 'boxWide') {
          this.formInfo.data[name] = value
        } else {
          this.formInfo2.data[name] = value
        }
        // console.log(this.formInfo.data, 'this.formInfo.data')
        callback()
      }
    },
    checkCharacter (rule, value, callback) { // 商品条码
      let reg = /^[a-zA-Z0-9_\u4e00-\u9fa5]{0,30}$/
      if (!reg.test(value)) {
        return callback(new Error('请输入0-30位中文、英文或数字'))
      }
      callback()
    },
    getCompany () {
      let params = {parentCode: 'GOOD_UNIT'}
      this.$store.dispatch(GETCOMPANY, params)
    }
  }
}
export default mixin



// WEBPACK FOOTER //
// ./src/page/goodsManage/components/mixin.js